import { hasPermission } from "./permissions.js";
import { PERMISSIONS } from "./permissionKeys.js";

// Explore right-column (detail panel) mode rules.
//
// The right column toggles between "chat" and "context". "context" is only
// meaningful when there's something to put in it. When the comparisons surface
// is on, the Contrast grid is that always-present filler; with it off, context
// is meaningful only while a specific detail is mounted (a trace, a lens
// detail, a pinned cell, a command, a signal view, or a memory override).
//
// ScopedPage uses this for two things kept in lockstep: whether to offer the
// "Context" button on the mode rail, and whether to fall back to chat when
// "context" is selected but empty.
export function contextModeAvailable({ comparisons, hasContextDetail }) {
    return Boolean(comparisons || hasContextDetail);
}

// "chat" needs the LLM provider descriptor (tenant.llm_config.read) —
// without it the console's creds fetch 403s on both the narrow and legacy
// paths, so the mode must not be offered at all. Fails open while caps are
// loading / unavailable / degraded, like every affordance gate
// (see permissions.js); App unmounts the ChatConsole singleton on the same
// predicate.
export function chatModeAvailable(caps) {
    return hasPermission(caps, PERMISSIONS.LLM_CONFIG_READ);
}

// The rail's mode entries, in display order. Kept here with the two
// availability rules so the offered modes and the fallback steers can't
// drift apart; ScopedPage attaches the glyphs.
export function rightPanelModes({ contextAvailable, canChat }) {
    return [
        ...(contextAvailable ? [{ id: "context", label: "Context" }] : []),
        ...(canChat ? [{ id: "chat", label: "Chat" }] : []),
    ];
}

// Steer for a chat-denied role: "chat" (the default) falls back to context;
// any other mode stands. Null = leave the mode alone.
export function panelModeDeniedFallback(panelMode, canChat) {
    return !canChat && panelMode === "chat" ? "context" : null;
}
